import { Select } from '@radix-ui/themes';
import { useGetDiscordBotQuery } from '../../graphql/queries/GetDiscordBot.generated';

interface DiscordBotChannelSelectProps {
  botId?: string;
  channelId?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const DiscordBotChannelSelect = ({
  botId,
  channelId,
  onValueChange,
  disabled,
}: DiscordBotChannelSelectProps) => {
  const isDisabled = disabled || !botId;
  const { data, loading, error } = useGetDiscordBotQuery({
    variables: { id: botId },
    skip: !botId,
  });

  if (!botId) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Select a bot first"
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  if (loading) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Loading channels..."
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  if (error || !data?.discordBot) {
    return (
      <Select.Root disabled={true}>
        <Select.Trigger
          placeholder="Error loading channels"
          style={{ width: '100%' }}
        />
      </Select.Root>
    );
  }

  const channels = data.discordBot.channels.filter(
    (channel) => !channel.isArchived,
  );

  return (
    <Select.Root
      value={channelId}
      onValueChange={onValueChange}
      disabled={isDisabled}
    >
      <Select.Trigger
        placeholder={
          channels.length === 0 ? 'No channels found' : 'Select a channel'
        }
        style={{ width: '100%' }}
      />
      <Select.Content>
        {channels.map((channel) => (
          <Select.Item key={channel.id} value={channel.id}>
            {channel.name || `Channel ${channel.id}`}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default DiscordBotChannelSelect;
